// extracted by mini-css-extract-plugin
export default {"Btn":"BurgerMenuToggle_Btn__dSCK6"};